// Friendly error message extraction. Axios errors are noisy and the
// raw .message is usually "Request failed with status code 500" which
// tells the user nothing. Walk the response shape and pull out the
// most-useful string.
//
// Order of preference:
//   1. response.data.message (NestJS standard error shape)
//   2. response.data.error
//   3. response.data when it's a string
//   4. error.message (axios default)
//   5. fallback string
export function extractErrorMessage(err: any, fallback = 'Something went wrong. Please try again.'): string {
  if (!err) return fallback;

  // class-validator errors arrive as message: string[]
  const data = err?.response?.data;
  if (data) {
    if (Array.isArray(data.message)) {
      return data.message.filter(Boolean).join(', ') || fallback;
    }
    if (typeof data.message === 'string' && data.message) return data.message;
    if (typeof data.error === 'string' && data.error) return data.error;
    if (typeof data === 'string' && data) return data;
  }

  // Network errors / timeouts surface here
  if (err?.code === 'ECONNABORTED') return 'The server took too long to respond. Try again.';
  if (err?.message === 'Network Error') return 'Cannot reach the server. Check your internet connection.';

  if (typeof err?.message === 'string' && err.message && !err.message.includes('status code')) {
    return err.message;
  }
  return fallback;
}
